<template src="./App.html"></template>
<script>
export default {
  name: 'App',
  props: ['user'],
  data() {
    return {}
  }
}
</script>
